<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <main-group-create-or-update v-model="mainGroup" :errors="errors"></main-group-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :buttons="buttons"
                    name="main-group"
                    :add-callback="createNew"
                    search
                    pagination="server"
                    :fields="fields"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import MainGroupCreateOrUpdate from './components/MainGroupCreateOrUpdate.vue'
import MaintenanaceOperationsApi from '@/api/maintenance-operations'
export default {
    components:{
        BCard,
        MainGroupCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Kod",key:"Code",thClass:"w-15",sortable:true},
                {name:"Ana Grup",key:"Name",thClass:"w-85",sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            mainGroup:{
                Id:null,
                Name:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.mainGroup.Id = null
            this.mainGroup.Name = null
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.mainGroup.Id = item.Id
            this.mainGroup.Name = item.Name
            this.$showModal("create-or-update")
        },
        createNew(){
            this.clearForm()
            this.$showModal("create-or-update")
        },
        provider(data){
            return MaintenanaceOperationsApi.MainGroup.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            MaintenanaceOperationsApi.MainGroup.CreateOrUpdate(this.editing,this.mainGroup).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal("create-or-update")
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} ana grubunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    MaintenanaceOperationsApi.MainGroup.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>